import getters from './getters';
import mutations from './mutations';
function initState() {
    return {
        testimonials: [],
        agent:{},
        agentid:-1
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions:{}
};
